export function applyChanges(target, changes) {
    for (const key of Object.keys(changes)) {
        target[key] = changes[key];
    }
}
export function hasAnyChange(target, changes) {
    for (const key of Object.keys(changes)) {
        if (target[key] !== changes[key]) {
            return true;
        }
    }
    return false;
}

//# sourceMappingURL=changes.js.map
